// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import EmojiPopupWrapper from '../../components/emoji/popup/EmojiPopupWrapper';
import ReactionsPopupContent from './popup/ReactionsPopupContent';

type ElementReactionPopupProps = {
    className?: string;
    popupId: string;
    elementIds: string[];
};

const ElementReactionPopup: React.FC<ElementReactionPopupProps> = (props) => {
    const { className, popupId, elementIds } = props;
    return (
        <EmojiPopupWrapper className={classNames('ReactionPopup', className)} popupId={popupId}>
            {(gridSize, closePopup) => (
                <ReactionsPopupContent gridSize={gridSize} closePopup={closePopup} elementIds={elementIds} />
            )}
        </EmojiPopupWrapper>
    );
};

export default ElementReactionPopup;
